export const QT2GServerValuesModel = {
    pin: "-1",
    apn_name: "-1",
    apn_user: "-1",
    apn_pass: "-1",
}
export const QT2GServerHasModel = {
    has_pin: false,
    has_apn_name: false,
    has_apn_user: false,
    has_apn_pass: false,
}